import { CmsApiThreeSectionSliderBlockData } from 'modules/cms/api/types/blocks/CmsApiThreeSectionSliderBlock';
import { CmsAmpCardsBlock } from 'modules/cms/blocks/Amp/Cards';
import { CmsAmpBlockMappingComponentProps } from 'modules/cms/blocks/CmsBlockMapping';

export function CmsAmpThreeSectionSliderBlock({
  content,
  blockId,
  data,
}: CmsAmpBlockMappingComponentProps<CmsApiThreeSectionSliderBlockData>) {
  return (
    <CmsAmpCardsBlock
      content={content}
      blockId={blockId}
      data={{
        ...data,
        headline: data.headline,
        // @ts-expect-error TS(2322): Type 'CmsApiThreeSectionSliderImageSizes' is not a... Remove this comment to see the full error message
        imageSize: data.imageSize,
        cards: data.sections.map((section) => ({
          text: section.content,
          image: section.image,
        })),
      }}
    />
  );
}
